angular.module('TurneroApp').component('coEncuestasOpciones', {
    bindings: {
        centroAtencionSeleccionado: '<',
        ctrlPadre: '='
    },
    controller: [
        'encuestasService',
        'utilsService',
        'TurneroAppConstant',
        function (encuestasService, utilsService, TurneroAppConstant) {
            var ctrl = this;

            ctrl.acciones = TurneroAppConstant.Acciones;
            ctrl.accion = null;
            ctrl.encuesta = {};
            ctrl.lstAgendaTramite = [];

            ctrl.errores = {
                Nombre: false,
            };

            ctrl.$onInit = function () {
                ctrl.ctrlPadre.tLoadOpciones = function (pAccion, item) {
                    ctrl.accion = pAccion;
                    ctrl.encuesta = item;
                    ctrl.lstAgendaTramite = [];
                    ctrl.errores = {};

                    if (ctrl.accion != ctrl.acciones.Crear && item && item.Id_Encuesta) {
                        ctrl.promise = encuestasService.getPasoOpciones({ 'id_encuesta': item.Id_Encuesta }).$promise.then(function (res) {
                            ctrl.encuesta = res.Data;
                            ctrl.encuesta.Id_Encuesta = item.Id_Encuesta;
                            ctrl.lstAgendaTramite = ctrl.encuesta.Agendas_Tramites;
                        }).catch(function (req) {
                            utilsService.errores(req);
                            ctrl.ctrlPadre.cancelar();
                        });
                    }

                    ctrl.filtrarAgendas();
                    ctrl.filtrarTramites();
                }

                ctrl.ctrlPadre.guardarOpciones = function () {

                    if (ctrl.lstAgendaTramite.length == 0) {
                        swal({
                            title: 'Debe cargar alguna combinación de Agenda/Trámite',
                            type: 'warning',
                            confirmButtonColor: '#004b81',
                            confirmButtonText: "Aceptar"
                        });

                        return false;
                    }

                    utilsService.swalTitle('Procesando datos', 'info');

                    if (ctrl.accion == ctrl.acciones.Editar || ctrl.accion == ctrl.acciones.Crear) {
                        ctrl.encuesta.Agendas_Tramites = ctrl.lstAgendaTramite;

                        return encuestasService.putPasoOpciones(ctrl.encuesta).$promise.then(function (res) {
                            ctrl.ctrlPadre.nextTab();
                            swal.close();
                        }).catch(function (req) {
                            swal.close();
                            utilsService.errores(req);
                        });
                    }
                    else {
                        swal.close();
                    }

                    return true;
                }
            }

            ctrl.filtrarAgendas = function () {
                encuestasService.getComboAgendas({
                    'id_centro_atencion': ctrl.centroAtencionSeleccionado.id,
                    'id_tramite': ctrl.tramiteSeleccionado
                }).$promise.then(function (data) {
                    ctrl.agendas = data.Data;
                    ctrl.agendas.unshift({ id: null, text: 'TODAS' });
                }).catch(function (error) {
                    utilsService.errores(error);
                });
            };

            ctrl.borrarComboAgendas = function () {
                ctrl.agendaSeleccionada = undefined;

                if (ctrl.tramiteSeleccionado == undefined)
                    ctrl.filtrarTramites();
            }

            ctrl.filtrarTramites = function () {
                encuestasService.getComboTramites({
                    'id_centro_atencion': ctrl.centroAtencionSeleccionado.id,
                    'id_agenda': ctrl.agendaSeleccionada
                }).$promise.then(function (data) {
                    ctrl.tramites = data.Data;
                    ctrl.tramites.unshift({id: null, text: 'TODOS'});
                }).catch(function (error) {
                    utilsService.errores(error);
                });
            };

            ctrl.borrarComboTramites = function () {
                ctrl.tramiteSeleccionado = undefined;

                if (ctrl.agendaSeleccionada == undefined)
                    ctrl.filtrarAgendas();
            }

            ctrl.createFilterFor = function (query) {
                var upperQuery = angular.uppercase(query);

                return function filterFn(item) {
                    let texto = utilsService.removeAccents(angular.uppercase(item.N_Opcion_Calificacion))
                    return (texto.indexOf(upperQuery) >= 0);
                };
            }

            ctrl.agregarAgendaTramite = function () {
                let existeAgenda = false;
                let existeTramite = false;

                if (ctrl.agendaSeleccionada === null)
                    existeAgenda = ctrl.lstAgendaTramite.length > 0;
                else
                    existeAgenda = (ctrl.lstAgendaTramite.findIndex(x => x.Id_Agenda === null || x.Id_Agenda == ctrl.agendaSeleccionada) != -1);

                if (ctrl.tramiteSeleccionado === null)
                    existeTramite = ctrl.lstAgendaTramite.length > 0;
                else
                    existeTramite = (ctrl.lstAgendaTramite.findIndex(x => x.Id_Tramite_Relevado === null || x.Id_Tramite_Relevado == ctrl.tramiteSeleccionado) != -1);

                if (existeAgenda && existeTramite) {
                    swal({
                        title: 'Existe una combinación de trámite y agenda repetida',
                        type: 'warning',
                        confirmButtonColor: '#004b81',
                        confirmButtonText: "Aceptar"
                    });
                }
                else {
                    let agenda = ctrl.agendas.find(x => x.id === ctrl.agendaSeleccionada);
                    let tramite = ctrl.tramites.find(x => x.id === ctrl.tramiteSeleccionado);

                    //agrego la pregunta a la grilla
                    ctrl.lstAgendaTramite.push({
                        Id_Agenda: agenda.id,
                        N_Agenda: agenda.text,
                        Id_Tramite_Relevado: tramite.id,
                        N_Tramite: tramite.text
                    });

                    ctrl.agendaSeleccionada = undefined;
                    ctrl.tramiteSeleccionado = undefined;
                    ctrl.filtrarAgendas();
                    ctrl.filtrarTramites();
                }
            }

            ctrl.eliminarAgendaTramite = function (item) {
                let i = ctrl.lstAgendaTramite.findIndex(x => x.Id_Agenda == item.Id_Agenda && x.Id_Tramite == item.Id_Tramite);

                if (i != -1) {
                    ctrl.lstAgendaTramite.splice(i, 1);
                }
            }
        }
    ],
    template: require('./encuestasOpciones.html')
});


// WEBPACK FOOTER //
// ./app/components/supervision/encuestas/encuestasOpcionesComponent.js